/**
 * SelectPaymentMethodHeader component
 *
 * Header específico para la pantalla de selección de método de pago.
 * Muestra el título "Selecciona método de pago" y botón opcional para agregar.
 */

import { FC, useState } from 'react';
import { translate } from '../../i18n';
import { headerStyles } from './styles';

export interface SelectPaymentMethodHeaderProps {
  /** Título principal (fallback: traducción) */
  readonly title?: string;
  /** Callback para botón "Agregar" */
  readonly onAddPress?: () => void;
  /** Texto del botón agregar (fallback: traducción) */
  readonly addButtonLabel?: string;
  /** ID de prueba */
  readonly testID?: string;
  /** Etiqueta de accesibilidad */
  readonly accessibilityLabel?: string;
}

/**
 * SelectPaymentMethodHeader - Componente thin presentational
 */
export const SelectPaymentMethodHeader: FC<SelectPaymentMethodHeaderProps> = ({
  title = translate('paymentsUI.header.title'),
  onAddPress,
  addButtonLabel = translate('paymentsUI.header.addButton'),
  testID = 'select-payment-method-header',
  accessibilityLabel,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isActive, setIsActive] = useState(false);

  return (
    <header
      data-testid={testID}
      aria-label={accessibilityLabel || title}
      role="banner"
      style={headerStyles.header}
    >
      <div style={headerStyles.headerContainer}>
        <h2 style={headerStyles.title}>{title}</h2>

        {onAddPress && (
          <button
            onClick={onAddPress}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onMouseDown={() => setIsActive(true)}
            onMouseUp={() => setIsActive(false)}
            data-testid={`${testID}-add-button`}
            aria-label={translate('paymentsUI.header.addButtonLabel')}
            style={{
              ...headerStyles.addButton,
              ...(isHovering && headerStyles.addButtonHover),
              ...(isActive && headerStyles.addButtonActive),
            }}
          >
            {addButtonLabel}
          </button>
        )}
      </div>
    </header>
  );
};
